import moment from 'moment';

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_TIME_FORMAT = 'HH:mm:ss';

const PARSE_FORMATS: string[] = [
  'YYYY-MM-DD HH:mm:ss.SSS',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD',
  'YYYYMMDDHHmmss',
  'YYYYMMDD',
  'YYMMDD',
  'HH:mm:ss.SSS',
  'HH:mm:ss',
  'HH:mm',
];

const ISO_REGEX = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:?\d{2})$/;

const parseValue = (value: string, format?: string) => {
  // ISO values carry their own offset (e.g. '2026-08-13T00:00:00Z'); keep it so
  // the rendered date/time matches the supplied value instead of the browser's.
  if (ISO_REGEX.test(value)) {
    const iso = moment.parseZone(value, moment.ISO_8601, true);
    if (iso.isValid()) return iso;
  }

  const candidates = format ? [format, ...PARSE_FORMATS] : PARSE_FORMATS;

  for (const candidate of candidates) {
    const parsed = moment(value, candidate, true);
    if (parsed.isValid()) return parsed;
  }

  const iso = moment(value, moment.ISO_8601, true);

  return iso.isValid() ? iso : undefined;
};

export const dateColumn = (
  value: any,
  format?: string,
  defaultFormat: string = DEFAULT_DATE_FORMAT
) => {
  const date = String(value).trim();

  if (date === '' || date === 'undefined' || date.includes('null')) return '';

  const parsed = parseValue(date, format);

  if (!parsed) return date;

  return parsed.format(format || defaultFormat);
};
